<template>
  <v-navigation-drawer
    id="drawer"
    app
    clipped
    class="background lighten-5"
    :width="350"
    :permanent="showDrawer"
    floating
  >
    <v-container fluid class="px-8">
      <v-list dense>
        <v-list-item-group>
          <v-card outlined tile>
            <v-list-item
              link
              class="background subtitle-2 black--text px-4"
              to="/"
              data-cy="sb-title"
              ><span>{{ title }}</span></v-list-item
            >
          </v-card>
          <template v-for="item in items">
            <v-card outlined tile v-if="item.isVisible" :key="item.text">
              <v-list-item link :to="item.path" :data-cy="'sb-' + item.text">
                <span class="primary--text">{{ item.text }}</span>
              </v-list-item>
            </v-card>
          </template>

          <v-spacer
            class="my-2 py-2"
            v-if="bottomItems !== undefined"
          ></v-spacer>
          <slot name="sidebar-center"></slot>
          <v-spacer
            class="my-2 py-2"
            v-if="bottomItems !== undefined"
          ></v-spacer>

          <template v-for="item in bottomItems">
            <v-card outlined tile v-if="item.isVisible" :key="item.text">
              <v-list-item link :to="item.path" :data-cy="'sb-' + item.text">
                <span class="primary--text">{{ item.text }}</span>
              </v-list-item>
            </v-card>
          </template>
        </v-list-item-group>
      </v-list>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
    items: {
      required: true,
      type: Array,
    },
    bottomItems: {
      type: Array,
    },
    ungroupedLights: {
      type: Array,
      default: function () {
        return [];
      },
    },
    title: {
      required: true,
      type: String,
    },
  },
};
</script>

<style scoped>
.border {
  background-color: white;
  width: 300px;
}
.theme--light.v-card {
  border: thin solid black;
  margin-bottom: -1px;
}
</style>
